<script>
  export let size = 'md'; // sm, md, lg
  export let message = '';
  export let centered = true;
  export let overlay = false;
</script>

{#if overlay}
  <div class="loading-overlay">
    <div class="loading-content">
      <div class="loading-spinner loading-spinner-{size}"></div>
      {#if message}
        <div class="loading-message">{message}</div>
      {/if}
    </div>
  </div>
{:else}
  <div class="loading-container" class:loading-centered={centered}>
    <div class="loading-spinner loading-spinner-{size}"></div>
    {#if message}
      <div class="loading-message">{message}</div>
    {/if}
  </div>
{/if}

<style>
  .loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
  }

  .loading-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
  }

  .loading-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
    padding: 20px;
  }

  .loading-centered {
    justify-content: center;
    min-height: 200px;
  }

  .loading-spinner {
    border-radius: 50%;
    animation: spin 1s linear infinite;
    border-style: solid;
    border-color: #f3f3f3;
    border-top-color: #3273dc;
  }

  .loading-spinner-sm {
    width: 24px;
    height: 24px;
    border-width: 3px;
  }

  .loading-spinner-md {
    width: 40px;
    height: 40px;
    border-width: 4px;
  }

  .loading-spinner-lg {
    width: 60px;
    height: 60px;
    border-width: 6px;
  }

  .loading-message {
    color: #666;
    font-size: 1rem;
    text-align: center;
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  @media (prefers-reduced-motion: reduce) {
    .loading-spinner {
      animation: none;
      border: 4px solid #3273dc;
    }
  }
</style> 